import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import {catchError} from 'rxjs/operators';


@Injectable()
export class ReceiversService extends BaseHttpService {

  public changeStatuses(brandId: string, receiverIds: string[], filter: any, status: number): Observable<any> {
    const body = JSON.stringify({ filter, receiverIds, status });

    return this.http.put(
      `${Config.API}/receivers/${brandId}/status`,
      body,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }

  public fetchTags(brandId: string): Observable<any> {
    return this.http.get(
      `${Config.API}/receivers/${brandId}/tags`,
      {headers: contentHeaders}
    )
        .pipe(catchError(this.handleError.bind(this)));
  }
}
